import React      from 'react';
import PropTypes  from 'prop-types';
import classNames from 'classnames';

import * as S              from './qem-advert.module.scss';
import { getEStoreCartUrlAddProduct } from '../../../../helpers/route-helper';
import { useGlobalCtx }        from '../../../../context/ctx-hook';
import { Price } from '../../../common/product/price';

import { TagLine } from '../../../common/product/tag-line';
import * as ProductSelectors  from '../../../../context/selectors/product-selectors';
import BLURPLE_CHECK from '../../../../assets/imgs/icons/circle-check-blurple.svg';
import { getProductLogo } from '../../../../context/selectors/product-selectors';




const QemAdvert = () => {
  const {state} = useGlobalCtx();

  const country = state.country === 'us' ? 'us' : 'ca';
  const PRODUCT = 'quicken-estate-backup';
  const PRODUCT_TIER_URI = 'qem-basic';
  // hacky but whatever, for getProductLogo which takes the full sub obj to return a logo, can clean up later
  const sub = {
    productLineUriName: PRODUCT
  };

  const SKU = state.defaultSkus[country][PRODUCT_TIER_URI];
  const PRICE =  ProductSelectors.getPriceBySku(state, SKU);
  const renewalFrequency = 'P1Y';

  return (
    <>
      <div className={S.cardTop}>
        <div className={S.logoHeader}>
          <img alt="square product logo" src={getProductLogo(sub)} />
          <h3 className={S.productName}>Quicken Lifehub</h3>
        </div>
        <TagLine uriName={'qem-basic'} className={S.qknTagLine} />
        <Price price={PRICE} product={PRODUCT} renewalFrequency={renewalFrequency} className={S.price} />
      </div>

      <span className={S.dash}/>

      <ul className={S.featureList}>
        <li>
          <span className={S.checkmark}><img src={BLURPLE_CHECK} alt="Checkmark Icon" /></span>
          Organize essential life info-beyond your finances
        </li>
        <li>
          <span className={S.checkmark}><img src={BLURPLE_CHECK} alt="Checkmark Icon" /></span>
          Step-by-step guidance makes it easy to start
        </li>
        <li>
          <span className={S.checkmark}><img src={BLURPLE_CHECK} alt="Checkmark Icon" /></span>
          Securely share with those you trust
        </li>
      </ul>

      <span className={S.dash}/>

      <a
        type="button"
        href={getEStoreCartUrlAddProduct(SKU, country)}
        className={S.contentCTABtn}
        data-testid="ADVERT_BTN_QEM_PURCHASE"
      >Get Started</a>
    </>
  );
};

QemAdvert.displayName  = 'qemAdvert';
QemAdvert.propTypes    = {isModal: PropTypes.bool, listPosition: PropTypes.number};
QemAdvert.defaultProps = {isModal: false, listPosition: 0};

export { QemAdvert };
